import { motion } from "framer-motion";

export default function TakesCare() {
  return (
    <section data-testid="takes-care-section" className="bg-azure text-white py-16 lg:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, rotate: -12, scale: 0.85 }}
          whileInView={{ opacity: 1, rotate: 0, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="shrink-0"
        >
          <img
            src="/assets/takes-care-logo.jpg"
            alt="Semplificaffitto.it Takes Care!"
            className="w-32 h-32 lg:w-40 lg:h-40 rounded-full shadow-2xl border-4 border-white/30 animate-[spin_30s_linear_infinite]"
            data-testid="takes-care-stamp"
          />
        </motion.div>

        <div className="flex-1 text-center lg:text-left">
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7 }}
            className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight"
          >
            Takes Care!
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.05 }}
            className="mt-1.5 text-xs uppercase tracking-[0.3em] text-white/70 font-semibold"
          >
            Semplificaffitto.it
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-4 text-base lg:text-lg text-white/85 leading-relaxed max-w-2xl"
          >
            Il nostro simbolo è un uovo: fragile solo in apparenza, perché custodisce ciò che conta
            di più. Così trattiamo la tua casa — protetta dentro un guscio di garanzie, curata in
            ogni dettaglio, ogni giorno.
          </motion.p>
        </div>

        <motion.img
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          src="/assets/uovo-bianco.png"
          alt="L'uovo Semplificaffitto, simbolo di cura e protezione"
          className="w-16 lg:w-20 animate-floaty drop-shadow-2xl shrink-0"
          data-testid="takes-care-egg"
        />
      </div>
    </section>
  );
}
